import zhtwLocale from 'date-fns/locale/zh-TW'

const localeMap = {
  'zh-TW': zhtwLocale,
}

export default localeMap
